import { Injectable } from '@angular/core';
import type { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import type { Observable } from 'rxjs';
import { catchError, switchMap, throwError, timer } from 'rxjs';
import { DialogService } from '@technocom/ui/dialogs';
import { HttpStatusCode } from '@angular/common/http';

/**
 *
 * Перехватчик запросов для отображения: диалога с подтверждением при коде ошибки 428 (Precondition Required),
 * информационного диалога при коде ошибки 412
 */
@Injectable()
export class PreconditionInterceptor implements HttpInterceptor {
  constructor(private dialogService: DialogService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((response: HttpErrorResponse) => {
        if ((response.status as HttpStatusCode) === HttpStatusCode.PreconditionRequired) {
          // timer для того, чтобы окно с загрузкой не перекрывало окно с диалогом
          return timer(200).pipe(
            switchMap(() => {
              return this.dialogService
                .confirm({
                  title: 'Внимание!',
                  width: 400,
                  content: (response.error as Error).message,
                  acceptText: 'Все равно продолжить',
                  cancelText: 'Отмена',
                })
                .pipe(
                  switchMap(() => {
                    const request = req.clone({
                      headers: req.headers.set('Confirm-Re-Translate', 'true'),
                    });

                    return next.handle(request);
                  }),
                );
            }),
          );
        }

        if ((response.status as HttpStatusCode) === HttpStatusCode.PreconditionFailed) {
          // timer для того, чтобы окно с загрузкой не перекрывало окно с диалогом
          return timer(200).pipe(
            switchMap(() => {
              return this.dialogService
                .alert({
                  title: 'Внимание!',
                  content: (response.error as Error).message,
                })
                .pipe(
                  switchMap(() => {
                    return next.handle(req);
                  }),
                );
            }),
          );
        }

        return throwError(() => response);
      }),
    );
  }
}
